import { keyframes } from '@emotion/react';
import theme from '@styles/theme';
const StickyAnimation = keyframes({
  from: {
    transform: 'translateY(-100%)',
    opacity: 0
  },
  to: {
    transform: 'translateY(0)',
    opacity: 1
  }
});
const StickyAnimationRevert = keyframes({
  from: {
    transform: 'translateY(0)',
    opacity: 1
  },
  to: {
    transform: 'translateY(-100%)',
    opacity: 0
  }
});
export default {
  stickyNav: (isSticky: boolean, layoutBarsTotalHeight = 0) => ({
    background: theme.rawColors.neutralWhite,
    width: '100%',
    position: 'fixed',
    transform: 'translateY(-100%)',
    opacity: 0,
    zIndex: theme.zIndex.contextMenu + 1,
    top: layoutBarsTotalHeight,
    left: 0,
    right: 0,
    transition: `position ${theme.transitions.time.normal} ${theme.transitions.animation.atomCurve}, top ${theme.transitions.time.normal} ${theme.transitions.animation.atomCurve}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: ['flex-start', 'flex-start', 'space-between'],
    boxShadow: `0px -1px 0px 0px ${theme.rawColors.shadowGrey} inset`,
    animation: isSticky ? `${StickyAnimation} .4s linear both` : `${StickyAnimationRevert} .4s linear both`,
    padding: ['0 0 0 20px', '0 0 0 20px', '0 20px', '0 20px', '0 40px'],
    height: ['56px', '56px', '56px', '56px', '72px']
  }),
  stickyLeftBox: {
    padding: ['8px 0', '8px 0', '8px 0', '8px 0', '8px 0'],
    display: 'flex',
    alignItems: 'center',
    svg: {
      transform: 'rotate(90deg)'
    },
    button: {
      display: 'flex',
      alignItems: 'center',
      background: 'transparent',
      border: 'none',
      height: '40px'
    }
  },
  productTitle: {
    ml: '27px',
    width: '100%',
    maxWidth: '345px',
    fontFamily: theme.fonts.uniformExtra,
    fontSize: theme.fontSizes.h3,
    lineHeight: '26px',
    letterSpacing: theme.letterSpacings.caps,
    textTransform: 'uppercase',
    color: theme.rawColors.darkGrey700,
    padding: ['0', '0', '0', '0', '4px 0 0 0'],
    display: ['none', 'none', 'none', 'none', 'flex'],
    alignItems: 'center',
    span: {
      overflow: 'hidden',
      display: '-webkit-box',
      WebkitLineClamp: '2',
      WebkitBoxOrient: 'vertical',
      textOverflow: 'ellipsis'
    }
  },
  stickyCart: {
    display: 'flex',
    '@media (max-width: 1060px)': {
      display: 'none'
    }
  },
  stickyAddToCart: {
    p: '16px 0',
    display: 'flex',
    '.a-voxPriceBox': {
      height: '40px',
      paddingLeft: '24px',
      paddingRight: '24px',
      '.a-voxPriceBox__content': {
        fontSize: '24px'
      }
    },
    '.a-voxButton': {
      height: '40px',
      fontSize: `${theme.fontSizes.text}px`,
      display: 'flex',
      alignItems: 'center',
      p: '8px 38px'
    }
  },
  expandMore: {
    '@media (max-width: 1500px)': {
      display: 'none'
    }
  },
  addToCartButton: {
    p: '8px 38px',
    fontSize: theme.fontSizes.text,
    fontWeight: theme.fontWeights.bold,
    letterSpacing: '0.1em'
  },
  stickyPriceBox: {
    fontFamily: theme.fonts.uniformExtra,
    padding: '0 20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.rawColors.neutralBlack,
    fontWeight: theme.fontWeights.medium,
    fontSize: theme.fontSizes.h3,
    backgroundColor: theme.rawColors.lightGrey300,
    lineHeight: '1em',
    letterSpacing: '0.05em'
  }
};